import { render } from "./ChatMessagesList.vue?vue&type=template&id=49b9a7c7&scoped=true"
import script from "./ChatMessagesList.vue?vue&type=script&lang=ts"
export * from "./ChatMessagesList.vue?vue&type=script&lang=ts"

import "./ChatMessagesList.vue?vue&type=style&index=0&id=49b9a7c7&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-49b9a7c7"

export default script